module.exports = __webpack_public_path__ + "static/acm-logo_white-a70e863bdf6e252edd4fdc9496f38a54.png";